import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { CardVaultContent } from './CardVaultContent';

export default function CardVaultPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <CardVaultContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
